import { Observable } from 'rxjs';
import {
  ApiService,
  CANCEL_PLAYER_GAME_PATH,
  CancelPlayerGameDto,
  CancelPlayerGamePathParams,
  DELETE_PLAYER_APPLICATION_PATH,
  DeletePlayerApplicationPathParams,
  PlayerLeaveReason,
  SEND_PLAYER_APPLICATION_PATH,
  SendPlayerApplicationPathParams,
  SendPlayerApplicationResponse
} from '@core-http';

export class GameApplicationsService extends ApiService {
  sendApplication(pathParams: SendPlayerApplicationPathParams): Observable<SendPlayerApplicationResponse> {
    const path: string = this.fillPathParams(SEND_PLAYER_APPLICATION_PATH, pathParams);

    return this.httpClient.post<SendPlayerApplicationResponse>(`${this.env.apiUrl}${path}`, null);
  }

  removeFromGame(pathParams: CancelPlayerGamePathParams, leaveReason?: PlayerLeaveReason): Observable<void> {
    const path: string = this.fillPathParams(CANCEL_PLAYER_GAME_PATH, pathParams);
    const body: CancelPlayerGameDto = { leaveReason };

    return this.httpClient.delete<void>(`${this.env.apiUrl}${path}`, { body });
  }

  removeApplication(pathParams: DeletePlayerApplicationPathParams): Observable<void> {
    const path: string = this.fillPathParams(DELETE_PLAYER_APPLICATION_PATH, pathParams);

    return this.httpClient.delete<void>(`${this.env.apiUrl}${path}`);
  }
}
